module.exports = "<v-checkbox [checkedValue]=data [disabled]=disabled></v-checkbox> ";